'use client';

import { createRoot } from 'react-dom/client';

const loadingId = 'spin-loading-root';

/// 显示 loading
export function showLoading(props?: { content?: React.ReactNode }) {
  if (document.getElementById(loadingId) === null) {
    const element = (
      <div className="w-screen h-screen fixed z-[9999] fixed top-0 left-0 flex items-center justify-center">
        <div className="w-28 h-28 bg-black/70 flex flex-col items-center justify-center rounded-lg">
          <div className="spin-loading"></div>
          {props?.content && <p className="text-white text-sm mt-2">{props?.content}</p>}
        </div>
      </div>
    );

    const container = document.createElement('div');
    container.id = loadingId;
    document.body.appendChild(container);
    const root = createRoot(container);
    root.render(element);
  }
}

/// 隐藏 loading
export function hideLoading() {
  const container = document.getElementById(loadingId);
  if (container !== null) {
    container?.parentNode?.removeChild(container);
  }
}

/// 轻提示 toast
export function showToast({
  content = null,
  duration = 3500,
}: {
  content: React.ReactNode;
  duration?: number;
}) {
  const toastId = 'toast-root';

  if (!!content && document.getElementById(toastId) === null) {
    hideLoading();

    const element = (
      <div className="w-screen h-screen fixed z-[9999] fixed top-0 left-0 flex items-center justify-center">
        <div className="max-w-60 bg-black/70 rounded-lg">
          <p className="text-white text-sm px-4 py-3 text-center select-none">{content}</p>
        </div>
      </div>
    );

    const container = document.createElement('div');
    container.id = toastId;
    document.body.appendChild(container);
    const root = createRoot(container);
    root.render(element);

    if (duration > 0) {
      setTimeout(() => {
        const container = document.getElementById(toastId);
        if (container !== null) {
          container?.parentNode?.removeChild(container);
        }
      }, duration);
    }
  }
}
